import { staticLinks } from '@/config/routingLinks';

import { TAccordionType } from '@/types/general/unions';
import ogrn from '../../public/docs/AboutCompany/ogrn.jpg';
import inn from '../../public/docs/AboutCompany/inn.jpg';

import IcHomeQuest from '@/components/Icons/IcHomeQuest';
import IcNews from '@/components/Icons/header/IcNews';
import IcPaper from '@/components/Icons/header/IcPaper';

export const meta = {
  title: 'Сахалинское ипотечное агенство - О нас',
  description:
    'Общество является коммерческой организацией, основной целью которого является организация системы жилищного ипотечного кредитования в Сахалинской области. Средства, получаемые от продажи жилья в строящихся ипотечных домах и от деятельности на рынке ипотечного кредитования, направляются на увеличение оборотных средств для дальнейшего инвестирования в жилищное строительство и увеличения объемов ипотечного кредитования жителей Сахалинской области.',
  keywords:
    'Наша компания, О нас, Ипотечное агенство, Сахалин, Безопасность, Удобство, Покупка, Продажа, Квартира. недвижимость',
};

export const name = {
  fullName: 'Акционерное общество «Сахалинское ипотечное агентство».',
  shortName: 'АО «СиА».',
  meaning:
    'АО «Сахалинское ипотечное агентство» зарегистрировано 19 июня 2015 года в Межрайонной инспекции Федеральной налоговой службы №1 по Сахалинской области.',
};

export const contacts = {
  phones: [
    {
      place: 'Приёмная',
      phone: '8 (424) 231-25-32',
    },
    {
      place: 'Отдел кредитования и продаж',
      phone: '8 (424) 231-25-31',
    },
    {
      place: 'Сектор абонентского обслуживания',
      phone: '8 (424) 231-25-37',
    },
    {
      place: 'Сектор эксплуатации имущества',
      phone: '8 (424) 231-22-36',
    },
    {
      place: 'Факс',
      phone: '8 (424) 231-25-33',
    },
  ],
  email: 'sakhipoteka@mail.ru',
};

export const founder =
  'Учредителем АО «Сахалинское ипотечное агентство» является Сахалинская область, в лице министерства имущественных и земельных отношений Сахалинской области в соответствии с распоряжением Правительства Сахалинской области от 05.06.2015 №255-р.<br /><br />Общество является коммерческой организацией, основной целью которого является организация системы жилищного ипотечного кредитования в Сахалинской области. Средства, получаемые от продажи жилья в строящихся ипотечных домах и от деятельности на рынке ипотечного кредитования, направляются на увеличение оборотных средств для дальнейшего инвестирования в жилищное строительство и увеличения объемов ипотечного кредитования жителей Сахалинской области.';

export const requisitesData = [
  { title: 'ИНН', description: '6501275110' },
  { title: 'КПП', description: '650101001' },
  { title: 'ОГРН', description: '1156501005066' },
  { title: 'ОКПО', description: '24583064' },
  {title: 'БИК', description: '044525411'},
  { title: 'Расчетный счет', description: '40601810108020009543' },
  { title: 'Банк', description: 'Филиал "Центральный" Банка ВТБ (ПАО)' },
  { title: 'Корр. счет', description: '30101810145250000411' },
  {
    title: 'Юридический/Фактический адрес',
    description: '693020, Сахалинская обл, Южно-Сахалинск г, ул. Дзержинского, д. 21, оф. 219.',
  },
  { title: 'Телефон', description: '8 (4242) 312-532' },
  { title: 'Генеральный директор ООО «ИР-8» - Управляющей организации АО «Сахалинское ипотечное агентство»', description: 'Медведев Андрей Аркадьевич' },
];

export const accordionData = [
  {
    title:
      'Свидетельство о постановке на учет российской организации в налоговом органе по месту нахождения',
    content: ogrn.src,
    type: 'image' as TAccordionType,
  },
  {
    title: 'Свидетельство о государственной регистрации юридического лица',
    content: inn.src,
    type: 'image' as TAccordionType,
  },
  {
    title: 'Политика обработки персональных данных АО «Сахалинское ипотечное агентство»',
    content: '/docs/AboutCompany/pol.pdf',
    type: 'file' as TAccordionType,
    downloadFileName: 'pol.pdf',
  },
  {
    title: 'Политика в области качества акционерного общества «Сахалинское ипотечное агентство»',
    content: [
      {
        href: '/docs/AboutCompany/Политика АО СИА.pdf',
        title: 'Скачать документ',
      },
      {
        href: '/docs/AboutCompany/25.0731.026.pdf',
        title: 'Скачать документ',
      },
    ],
    type: 'file' as TAccordionType,
  },
];

export const categoryData = [
  {
    title: 'Документы и Заявления',
    subtitle: 'Информация для заемщиков',
    icon: <IcPaper />,
    path: staticLinks.documents,
  },
  {
    title: 'Новости',
    subtitle: 'Читайте наш интересный блог',
    icon: <IcNews />,
    path: staticLinks.news,
  },
  {
    title: 'Вопросы',
    subtitle: '100+ вопросов',
    icon: <IcHomeQuest />,
    path: staticLinks.questions,
  },
];
